import { SvgIconProps } from './icon-props';

export default function IconOccupancy({
	fill = 'none',
	height = 25,
	role,
	width = 26,
}: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 26 25"
			fill={fill}
			role={role}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.7047 3.58807C15.2126 2.36195 16.4091 1.5625 17.7362 1.5625C19.5484 1.5625 21.0175 3.03157 21.0175 4.84375C21.0175 6.17089 20.218 7.36735 18.9919 7.87523C17.7658 8.3831 16.3544 8.10238 15.416 7.16394C14.4776 6.22551 14.1969 4.81419 14.7047 3.58807ZM17.7362 2.65625C18.9443 2.65625 19.9237 3.63563 19.9237 4.84375C19.9237 6.05187 18.9443 7.03125 17.7362 7.03125C16.5281 7.03125 15.5487 6.05187 15.5487 4.84375C15.5487 3.63563 16.5281 2.65625 17.7362 2.65625ZM5.00496 8.125C5.00496 6.31282 6.47402 4.84375 8.28621 4.84375C10.0984 4.84375 11.5675 6.31282 11.5675 8.125C11.5675 9.93718 10.0984 11.4062 8.28621 11.4062C6.47402 11.4062 5.00496 9.93718 5.00496 8.125ZM8.28621 5.9375C9.49433 5.9375 10.4737 6.91688 10.4737 8.125C10.4737 9.33312 9.49433 10.3125 8.28621 10.3125C7.07808 10.3125 6.09871 9.33312 6.09871 8.125C6.09871 6.91688 7.07808 5.9375 8.28621 5.9375ZM21.9471 9.21875H13.5253C12.9858 9.21868 12.4689 9.43521 12.0905 9.81975C11.7121 10.2043 11.504 10.7247 11.5128 11.2641V12.5H4.07527C3.53579 12.4999 3.01886 12.7165 2.64049 13.101C2.26211 13.4855 2.05397 14.0059 2.06277 14.5453V22.9375C2.06277 23.2136 2.28663 23.4375 2.56277 23.4375H14.0096C14.2858 23.4375 14.5096 23.2136 14.5096 22.9375V20.1562H23.4378C23.7139 20.1562 23.9378 19.9324 23.9378 19.6562V11.2641C23.9465 10.7284 23.7414 10.2114 23.3677 9.82749C22.9941 9.44359 22.4828 9.2245 21.9471 9.21875ZM21.9471 10.3125C22.4546 10.3125 22.8659 10.7238 22.8659 11.2312V19.0625H14.5096V14.5453C14.506 13.5652 13.793 12.7319 12.8253 12.5766H12.6175V11.2641C12.6086 11.0166 12.7 10.7761 12.8709 10.597C13.0418 10.4179 13.2777 10.3153 13.5253 10.3125H21.9471ZM3.15652 14.5453V22.3438H13.405V14.4797C13.3973 14.0264 13.0565 13.6483 12.6065 13.5938H4.07527C3.82581 13.5936 3.58701 13.6949 3.41373 13.8743C3.24046 14.0538 3.14761 14.296 3.15652 14.5453Z"
				fill="#030303"
			/>
		</svg>
	);
}
